export default {"src":"/_next/static/media/login-img.92136a3e.gif","height":600,"width":600,"blurWidth":0,"blurHeight":0};